import { initializeApp, getApps } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFunctions } from 'firebase/functions'
import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
  apiKey: 'AIzaSyBFaLB2MF84k4PaM7H008gPIsJD-Ukh_hs',
  authDomain: 'ziel-app-f6320.firebaseapp.com',
  projectId: 'ziel-app-f6320',
  storageBucket: 'ziel-app-f6320.appspot.com',
  messagingSenderId: '249876699471',
  appId: '1:249876699471:android:ab5c28b55d36e4c535cd3a'
}

const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0]

const auth = getAuth(app)
const functions = getFunctions(app)
const db = getFirestore(app)

export { app, auth, functions, db }
